<template>
  <v-dialog v-model="localShow" max-width="600">
    <v-card>
      <v-card-title :class="isEditing ? 'bg-primary' : 'bg-success'" class="text-white">
        <v-icon class="mr-2">{{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
        {{ isEditing ? 'Edit Quarantine Duration' : 'Add Quarantine Duration' }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="form">
          <v-autocomplete
            v-model="localForm.service_id"
            :items="services"
            item-value="id"
            item-title="name"
            label="Service *"
            :rules="[v => !!v || 'Service is required']"
            outlined
            dense
            clearable
          ></v-autocomplete>

          <v-select
            v-model="localForm.property_type"
            :items="propertyTypeOptions"
            item-value="value"
            item-title="label"
            label="Property Type *"
            :rules="[v => !!v || 'Property type is required']"
            outlined
            dense
          ></v-select>

          <v-select
            v-model="localForm.billing_period_id"
            :items="billingPeriods"
            item-value="id"
            item-title="name"
            label="Billing Period *"
            :rules="[v => !!v || 'Billing period is required']"
            outlined
            dense
          ></v-select>

          <v-text-field
            v-model.number="localForm.quarantine_value"
            label="Quarantine Value *"
            type="number"
            :rules="[v => v !== null && v !== '' && v >= 0 || 'Value must be >= 0']"
            outlined
            dense
            hint="Number of billing periods for quarantine"
            persistent-hint
          ></v-text-field>

          <v-switch
            v-model="localForm.active"
            label="Active"
            :color="localForm.active ? 'success' : 'error'"
            hide-details
          ></v-switch>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">
          {{ isEditing ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServiceQuarantineDurationDialog',
  props: {
    show: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    formData: { type: Object, default: () => ({}) },
    services: { type: Array, default: () => [] },
    billingPeriods: { type: Array, default: () => [] },
    saving: { type: Boolean, default: false }
  },
  emits: ['close', 'save'],
  data() {
    return {
      localForm: {
        id: null,
        service_id: null,
        property_type: null,
        billing_period_id: null,
        quarantine_value: 0,
        active: true
      },
      propertyTypeOptions: [
        { value: 'buy', label: 'Buy' },
        { value: 'rent', label: 'Rent' },
        { value: 'transfer', label: 'Transfer' }
      ]
    }
  },
  computed: {
    localShow: {
      get() { return this.show },
      set(val) { if (!val) this.$emit('close') }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.localForm = {
          id: this.formData.id || null,
          service_id: this.formData.service_id || null,
          property_type: this.formData.property_type || null,
          billing_period_id: this.formData.billing_period_id || null,
          quarantine_value: this.formData.quarantine_value ?? 0,
          active: this.formData.active !== undefined ? this.formData.active : true
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      if (!this.localForm.service_id || !this.localForm.property_type || !this.localForm.billing_period_id) {
        return
      }
      this.$emit('save', { ...this.localForm })
    }
  }
}
</script>
